import { useEffect } from "react";
import { Alert, Badge, Button, Card } from "react-bootstrap";
import { FaCube, FaPlus, FaServer } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router";

import * as api from "../../api/api";
import { Breadcrumbs, breadcrumbPaths } from "../../components/Breadcrumbs";
import {
    CorvusList,
    CorvusListItem,
    CorvusListItemText,
} from "../../components/CorvusList";
import Layout, { Title } from "../../components/Layout/Layout";
import { useUser } from "../../contexts/user_provider";
import urls from "../../urls.jsx";

export default function DroneListPage() {
    const navigate = useNavigate();
    const { organizationId, locationId } = useParams();
    const [droneConfigs] = api.useDroneConfigsFromLocation(
        organizationId,
        locationId,
    );
    const { getUserIsAdmin } = useUser();

    useEffect(() => {
        if (!locationId || locationId === "undefined") {
            navigate(urls.locations(organizationId), { replace: true });
        }
    }, [locationId, organizationId, navigate]);

    return (
        <Layout>
            <title>Drones | MyCorvus</title>
            <Breadcrumbs path={breadcrumbPaths.droneList} />
            <Card>
                <Title
                    title={"Drones"}
                    backButtonUrl={urls.location(organizationId, locationId)}
                >
                    {getUserIsAdmin() &&
                        organizationId === api.CORVUS_ORGANIZATION_ID &&
                        locationId === "dMaW7ev8fg5GhoVJkqLT" && (
                            <Button
                                variant="outline-success"
                                as={Link}
                                to={urls.droneCreate(
                                    organizationId,
                                    locationId,
                                )}
                            >
                                <FaPlus className="me-2" />
                                New Drone
                            </Button>
                        )}
                </Title>
                {droneConfigs.length === 0 && (
                    <Alert variant="primary" className="mx-4 mb-4">
                        No drones
                    </Alert>
                )}
                {droneConfigs.length > 0 && (
                    <CorvusList>
                        {droneConfigs.map((droneConfig) => (
                            <CorvusListItem
                                className="p-0"
                                key={droneConfig.id}
                                as={Link}
                                to={urls.locationDrone(
                                    organizationId,
                                    locationId,
                                    droneConfig.id,
                                )}
                            >
                                <CorvusListItemText>
                                    Drone{" "}
                                    <span
                                        className="mx-1"
                                        style={{ fontFamily: "monospace" }}
                                    >
                                        {droneConfig.id}
                                    </span>
                                    {droneConfig.augmentation ===
                                        "EMULATION" && (
                                        <Badge bg="info" className="ms-2">
                                            <FaServer />
                                        </Badge>
                                    )}
                                    {droneConfig.augmentation ===
                                        "SIMULATION" && (
                                        <Badge bg="info" className="ms-2">
                                            <FaCube />
                                        </Badge>
                                    )}
                                </CorvusListItemText>
                            </CorvusListItem>
                        ))}
                    </CorvusList>
                )}
            </Card>
        </Layout>
    );
}
